export abstract class ActionLinkHandler {
  public abstract handle(type?: string): boolean;
}
